const PROJECT_WORK_ITEM_PREFIX_PATTERN = /^[A-Z][A-Z0-9]{1,9}$/;

/** Normalize a project work-item prefix to CMMD's uppercase token, or null. */
export function normalizeWorkItemPrefix(value: string | null | undefined): string | null {
  const normalized = value?.trim().toUpperCase() ?? "";
  return PROJECT_WORK_ITEM_PREFIX_PATTERN.test(normalized) ? normalized : null;
}

/**
 * Linear-style work-item identity: `CDT-261` when a valid project prefix is set,
 * otherwise `#261`.
 */
export function formatWorkItemId(prefix: string | null | undefined, id: number): string {
  const normalized = normalizeWorkItemPrefix(prefix);
  return normalized === null ? `#${id}` : `${normalized}-${id}`;
}
